import { useCaseGroups } from '@debbie/cortex/dist/case-groups/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState, } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
const MentionList = forwardRef((props, ref) => {
    const lang = useSelector((s) => s.lang);
    const caseGroupsLoader = useCaseGroups();
    const caseGroupLabelById = useMemo(() => Object.fromEntries((h.hasData(caseGroupsLoader) ? caseGroupsLoader.data : []).map((cg) => [
        cg.id,
        cg.label,
    ])), [caseGroupsLoader]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const selectItem = (index) => {
        const item = props.items[index];
        if (item) {
            props.command(item);
        }
    };
    const upHandler = () => {
        setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
    };
    const downHandler = () => {
        setSelectedIndex((selectedIndex + 1) % props.items.length);
    };
    const enterHandler = () => {
        selectItem(selectedIndex);
    };
    useEffect(() => setSelectedIndex(0), [props.items]);
    useImperativeHandle(ref, () => ({
        onKeyDown: ({ event }) => {
            if (event.key === 'ArrowUp') {
                upHandler();
                return true;
            }
            if (event.key === 'ArrowDown') {
                downHandler();
                return true;
            }
            if (event.key === 'Enter') {
                enterHandler();
                return true;
            }
            return false;
        },
    }));
    return (React.createElement(DropdownMenu, null, props.items.length ? (props.items.map((item, index) => {
        const caseGroupLabels = item.caseGroupIds
            .map((id) => caseGroupLabelById[id])
            .filter((label) => label != null);
        return (React.createElement(DropdownItem, { selected: index === selectedIndex, key: index, onClick: () => selectItem(index) },
            item.label,
            caseGroupLabels.length > 0 ? (React.createElement("span", { style: { fontSize: '0.8em', color: 'gray' } },
                ' ',
                "(",
                caseGroupLabels.join(', '),
                ")")) : null));
    })) : (React.createElement("div", { className: "item" }, lang.search.noResults))));
});
const DropdownMenu = styled.div `
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px;
  border: 1px solid lightgray;
  border-radius: 3px;
  min-width: 100px;
  max-width: 200px;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  background: white;
`;
const DropdownItem = styled.button `
  text-align: left;
  background: ${(props) => (props.selected ? '#d5e2ff' : 'white')};
  padding: 5px;
  border-radius: 3px;
  border: none;
  cursor: pointer;

  &:hover,
  &:hover.is-selected {
    filter: brightness(0.9);
  }
}
`;
export default MentionList;
//# sourceMappingURL=MentionList.js.map